<script setup lang="ts">
  // Renders the active tab content by mode: create/edit → order workspace,
  // view → read-only view workspace (keyed by draft so tab switches remount).
  import { computed } from 'vue';
  import { usePosDraftsStore } from '@/stores/pos-drafts.store';
  import PosV2ViewWorkspace from '@/components/pos-v2/view/PosV2ViewWorkspace.vue';
  import PosV2OrderWorkspace from './PosV2OrderWorkspace.vue';

  const posDrafts = usePosDraftsStore();

  const draft = computed(() => posDrafts.activeDraft);
  const isViewMode = computed(() => draft.value?.mode === 'view');
</script>

<template>
  <div class="pos-v2-order-content">
    <!-- Keyed by draft so per-tab UI state (menu search, category, mobile
         pane) never leaks across create/edit tabs. -->
    <PosV2OrderWorkspace v-if="draft && !isViewMode" :key="draft.id" />

    <PosV2ViewWorkspace
      v-else-if="draft && isViewMode && draft.orderId"
      :key="draft.id"
      :order-id="draft.orderId"
    />
  </div>
</template>

<style scoped lang="scss">
  .pos-v2-order-content {
    @apply tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden;
  }
</style>
